import EditExpenditure from './EditExpenditure.vue';

export default EditExpenditure;